@let isMobileMode = floatingPopupService.isMobileMode();

<div
  class="w-full h-full min-h-[24.375rem] flex flex-col gap-[0.75rem]"
  [gcElementWidthClass]=""
  [gcElementWidthClassIsActive]="!isMobileMode"
  #widthClass="gcElementWidthClass">
  @let data = loggerDeployment();
  @let isChartFullscreenActive = isChartFullscreen();
  @let chartDataAvailable = isChartDataExist();
  @let requestError = error();

  @if (data) {
   <div class="flex flex-col gap-0 h-full"
    [ngClass]="{
      'sm:pb-(--date-selection-reserved-height-for-sm-and-md) lg:pb-0': !isChartFullscreenActive
    }">
    <div class="w-full px-[0.75rem] sm:px-[1rem] pb-[0.75rem] flex items-center justify-between">
      <div class="flex items-center gap-1 flex-wrap">
        <gc-floating-popup-content-export-csv-actions
          [isDisabled]="!chartDataAvailable || !!requestError"
          [isLabelHidden]="!widthClass.activeClasses().includes('is-sm')"
          (export)="doExport()">
        </gc-floating-popup-content-export-csv-actions>

        <div class="self-center mr-[0.375rem] h-[1.25rem] min-w-[1px] w-[1px] bg-(--p-primary-100)"></div>

        <gc-floating-popup-select-date-range-action [facade]="rangeSelection"></gc-floating-popup-select-date-range-action>
      </div>

      @let currentPopup = popup();
      @if (currentPopup) {
        <gc-floating-popup-content-chart-actions class="self-end"
          [showThresholdColor]="true"
          [isLabelsHidden]="!widthClass.activeClasses().includes('is-sm')"
          [isChartFullscreen]="isChartFullscreenActive"
          (chartFullscreen)="toggleChartFullscreen()">
        </gc-floating-popup-content-chart-actions>
      }
    </div>

    @if (chartDataAvailable) {
      <div class="grow-1 min-h-0 flex flex-col px-[0.75rem] sm:px-[1rem]">
        @let chartCombinedData = combinedChartData();
        <gc-floating-popup-bar-chart-wrapper
          class="grow-1 h-full"
          [chartOptions]="chartCombinedData.chartOptions"
          [chartData]="chartCombinedData.chartData"
          [additionalPlugins]="chartPlugins">
        </gc-floating-popup-bar-chart-wrapper>
      </div>
    } @else {
      <div class="grow-1 items-center justify-center min-h-[6.25rem] flex flex-col px-[0.75rem] sm:px-[1rem]">
        <gc-floating-popup-base-error-message [requestError]="requestError"></gc-floating-popup-base-error-message>
      </div>
    }
   </div>
  }
</div>
